module.exports = __webpack_public_path__ + "img/crown_status.bb691c23.svg";